import { render, staticRenderFns } from "./AddLocationPrompt.vue?vue&type=template&id=59c84004"
import script from "./AddLocationPrompt.vue?vue&type=script&lang=js"
export * from "./AddLocationPrompt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports